(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coverking-color-swatches')) {
    customElements.define(
      'coverking-color-swatches',
      class CoverkingColorSwatches extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.onSwatchClick.bind(this));
        }

        onSwatchClick(event) {
          const button = event.target.closest('.coverking-color-swatches__button[data-media-target]');
          if (!button || !this.contains(button)) return;

          const gallery = document.getElementById(button.dataset.galleryId);
          if (!gallery?.setActiveMedia) return;

          gallery.setActiveMedia(button.dataset.mediaTarget, false);
          this.querySelectorAll('.coverking-color-swatches__button').forEach((swatchButton) => {
            swatchButton.setAttribute('aria-pressed', swatchButton === button ? 'true' : 'false');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
